export const entryPoint06Address = '0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789';
export const entryPoint07Address = '0x0000000071727De22E5E9d8BAf0edAc6f37da032';
export const ethAddress = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const zeroAddress = '0x0000000000000000000000000000000000000000';
//# sourceMappingURL=address.js.map